import { LegalTermsArchiveState } from '@pages/legal-terms-archive/store/state/legal-terms-archive.state';

export const legalTermsArchiveState = [LegalTermsArchiveState];
